import React from "react";
import styling from "./PurchaseItem.module.css";

function PurchaseItem() {
  return (
    <div className={styling.PurchaseItem}>
      <h1>Purchase Item</h1>
    </div>
  );
}

export default PurchaseItem;
